import * as React from "react";
import { forwardRef } from "react";
const SvgCancel = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M16.2008 7.80078L7.80078 16.2008M16.2008 16.2008L7.80078 7.80078L16.2008 16.2008Z", stroke: "#828282", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCancel);
export { ForwardRef as ReactComponent };
